import React from 'react';
import PropTypes from 'prop-types';
import {Paper, withStyles} from '@material-ui/core';
import {BottomContentStyles} from 'assets/tss/layouts/admin';
import {InferPropTypes} from 'commons/types/Types';

/**
 * Bottom Content container
 * @param props Styles & Prop Types.
 * @constructor
 */
function BottomContent(
    props: InferPropTypes<
        typeof BottomContent.propTypes,
        typeof BottomContentStyles
    >
) {
    const {classes, children} = props;
    return (
        <Paper elevation={0} square className={classes.root}>
            {children || 'Bottom'}
        </Paper>
    );
}

BottomContent.propTypes = {
    children: PropTypes.node,
};

export default withStyles(BottomContentStyles)(BottomContent);
